import type { StorageService, DocumentSummary } from './types'
import type { FFEDocument } from '../../../types/ffe'
import { apiClient } from '../../apiClient'
import { PaginatedResponse } from '../../types'

export class CloudStorageService implements StorageService {
  async saveDocument(document: FFEDocument): Promise<FFEDocument> {
    if (document._id) {
      return await apiClient.request(`/documents/${document._id}`, {
        method: 'PATCH',
        body: JSON.stringify(document)
      })
    } else {
      return await apiClient.request('/documents', {
        method: 'POST',
        body: JSON.stringify(document)
      })
    }
  }

  async loadDocument(id: string): Promise<FFEDocument | null> {
    try {
      return await apiClient.request(`/documents/${id}`)
    } catch (error) {
      console.error('Failed to load document:', error)
      throw error
    }
  }

  async listDocuments(): Promise<DocumentSummary[]> {
    const response = await apiClient.request<
      PaginatedResponse<DocumentSummary>
    >(
      '/documents?$limit=100&$select[]=_id&$select[]=id&$select[]=title&$select[]=projectTitle&$select[]=updatedAt&$select[]=createdAt'
    )
    return response.data
  }

  async deleteDocument(id: string): Promise<void> {
    await apiClient.request(`/documents/${id}`, {
      method: 'DELETE'
    })
  }
}
